import { useForm } from "react-hook-form";
import { FormHook } from "../../../components/molecules/FormHook"
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate"
import { FormDiv } from "../../../components/atoms/FormDiv";
import { FormInput } from "../../../components/molecules/FormInput";
import { SubmitButton } from "../../../components/atoms/SubmitButton";
import { useEffect, useState } from "react";
import { TITULO_HORARIO_REG } from "../../../utils/constantes";
import { FormSelect } from "../../../components/atoms/FormSelect";
import { getAllDias } from "../../../services/dia.service";
import { crearHorario } from "../../../services/horario.service";
import { showAlert, showErrorAlert } from "../../../components/molecules/ShowAlert";
import { useNavigate } from "react-router-dom";

export const RegistrarHorarioPage = () => {
  const {
    handleSubmit,
    register,
    control,
    formState: { errors }
  } = useForm();

  const [estaCargando, setEstaCargando] = useState(false);
  const [dias, setDias] = useState(false);
  const navigate = useNavigate();

  const obtenerDias = async () => {
    await getAllDias().then((dias) => {
      setDias(dias?.map((dia) => ({
        value: dia?.idDia,
        label: dia?.nombre,
      })));
    }).catch((err) => console.log(err));
  };

  useEffect(() => {
    obtenerDias()
  }, [])

  const submit = async (data) => {
    setEstaCargando(true)
    const dataDia = {
      horaInicio: data.horaInicio,
      horaFin: data.horaFin,
      idDia: data?.dia?.value
    }
    await crearHorario(dataDia).then(() => {
      setEstaCargando(false);
      showAlert({
        callback: () => {
          navigate("/horarios");
        },
      });
    }).catch((err) => {
      const errorMessage = err.response.data.message;
      showErrorAlert({ text: errorMessage })
    })
  }

  return (
    <ContenedorPageTemplate titulo={TITULO_HORARIO_REG}>
      <FormHook handleSubmit={handleSubmit} submit={submit} className="w-[min(100%,700px)] mx-auto">
        <FormDiv >
          <FormInput
            id="horaInicio"
            label="Hora de inicio"
            type="time"
            placeholder="Hora de Inicio"
            register={register}
            validation={{
              required: { value: true, message: "Campo requerido" }
            }}
            error={errors.horaInicio}
          />
          <FormInput
            id="horaFin"
            label="Hora de salida"
            type="time"
            placeholder="Hora de salida"
            register={register}
            validation={{
              required: { value: true, message: "Campo requerido" }
            }}
            error={errors.horaFin}
          />
          <FormSelect
            name="dia"
            label="Día"
            control={control}
            options={dias}
            isMulti={false}
            validation={{ required: "Campo requerido" }}
            placeholder="Seleccione un día"
            error={errors.dia}
          />
        </FormDiv>
        <SubmitButton estaCargando={estaCargando} />
      </FormHook>
    </ContenedorPageTemplate >
  )
}